import { INotification } from 'shared/types/notifications';
import { TApplicationState } from 'shared/types/redux';

export const selectNotifications = (state: TApplicationState): INotification[] => {
  return state.notifications.list;
};
